import produce from 'immer'

export const applyFilterUpdate = (draft, type, value) => {
	if (type === 'dateTime' || type === 'datePeriod') {
	  draft.from = value && value.from
	  draft.to = value && value.to
	  return draft
	}
	if (type === 'timePeriod') {
	  draft.timeStart = value && value.from
	  draft.timeEnd = value && value.to
	  return draft
	}

	draft[type] = value
	return draft
}

export default (state, { value, type }) => {
	if(type === 'hydrateFromSaved') {
		return value
	}
	return produce(state, draft => {
		switch(type) {
			case 'dateTime':
				draft.from = value.from
				draft.to = value.to
				break
			case 'datePeriod':
				draft.from = value.from
				draft.to = value.to
				break
			case 'timePeriod':
				draft.timeStart = value.from
				draft.timeEnd = value.to
				break
			default: draft[type] = value
		}
	})
}
